<template>
  <client-only>
    <div
      v-show="isPopoverVisible"
      class="new-navbar-mobile-menu z-30 overflow-hidden absolute shadow-lg bg-neutral-00"
    >
      <transition name="fade" appear>
        <div class="text-left" @click="onClickOutside">
          <button
            class="px-6 py-4 flex items-center border-b border-neutral-200"
            @click="$emit('locale')"
          >
            <OSvg :svg="icon" class="rounded w-7" />
            <p class="ml-2 o-body font-bold mr-12" v-text="localeName" />
            <OSvg svg="new-chevron-right" class="w-3 fill-neutral-800" />
          </button>
          <NuxtLink
            :to="`/${currentCategory}#how-it-works`"
            class="py-3 px-6 inline-block"
            @click.native="onMenuClick()"
          >
            <span class="o-body" v-text="$t('Navigation.HowDoesItWork')" />
          </NuxtLink>
          <NuxtLink v-if="isMen" to="/lookbook/men-originals" class="py-3 px-6 inline-block">
            <span class="o-body" v-text="$t('Navigation.Lookbook')" />
          </NuxtLink>
          <NuxtLink v-if="isWomen" to="/women/product" class="py-3 px-6 inline-block">
            <span class="o-body" v-text="$t('Navigation.Lookbook')" />
          </NuxtLink>
          <NuxtLink to="/customer-service" class="py-3 px-6 inline-block">
            <span class="o-body" v-text="$t('Navigation.FAQ')" />
          </NuxtLink>
        </div>
      </transition>
    </div>
  </client-only>
</template>

<script>
import { LocaleIcons, LocaleNames, Locales } from '@/enums/general'
import OSvg from '@/components/OSvg'
import { WebsiteCategories } from '@/enums/app'
import { ROUTER_HASH_UPDATED } from '@/events/eventTypes'

export default {
  name: 'MobileMenu',
  components: { OSvg },
  props: {
    locale: {
      type: String,
      default: Locales.nl
    }
  },
  data () {
    return {
      isPopoverVisible: false
    }
  },
  computed: {
    icon () {
      return LocaleIcons[this.locale]
    },
    localeName () {
      return LocaleNames[this.locale]
    },
    currentCategory () {
      const withoutLangParam = this.$route.name?.replace('lang-', '')

      if ((withoutLangParam ?? '').startsWith(WebsiteCategories.women)) {
        return WebsiteCategories.women
      }

      return WebsiteCategories.men
    },
    isMen () {
      return this.currentCategory === WebsiteCategories.men
    },
    isWomen () {
      return this.currentCategory === WebsiteCategories.women
    }
  },
  methods: {
    togglePopover (isVisible) {
      this.isPopoverVisible = isVisible
    },
    onClickOutside () {
      if (this.isPopoverVisible) {
        this.togglePopover(false)
      }
    },
    onMenuClick () {
      this.$fireEvent(ROUTER_HASH_UPDATED.event, '#how-it-works')
    }
  }
}
</script>

<style scoped lang="postcss">
.new-navbar-mobile-menu {
  border-radius: 1.6rem;
  width: min-content;
  top: 7rem;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

@screen lg {
  .new-navbar-mobile-menu {
    top: 11rem;
  }
}
</style>
